// extracted by mini-css-extract-plugin
module.exports = {"summary":"SharedSummary_summary_F1pIG","parameters":"SharedSummary_parameters_15IFQ","dates":"SharedSummary_dates_16vtl","ignored":"SharedSummary_ignored_1hsH4"};